import styled from 'styled-components'
import { tokens } from 'styling/tokens'
import { IStyledNavItem } from 'types/ui/navItem.interface'

export const StyledNavItem = styled.button<IStyledNavItem>`
  display: flex;
  align-items: center;
  gap: ${tokens.space.sm};
  width: 100%;
  height: 2.25rem;
  padding: 0 ${tokens.space.sm};
  border: none;
  background: transparent;
  border-radius: ${tokens.radius.nav};
  color: ${tokens.text.secondary};
  font-size: ${tokens.font.body};
  cursor: pointer;
  transition: background ${tokens.motion.duration} ${tokens.motion.ease};

  ${({ $active }) =>
    $active &&
    `background: ${tokens.accent.soft};
     color: ${tokens.accent.onDark};
     font-weight: 500;
     box-shadow: ${tokens.accent.navGlow};`}

  ${({ $collapsed }) =>
    $collapsed &&
    `width: 2.75rem;
     min-width: 2.75rem;
     max-width: 2.75rem;
     height: 2.75rem;
     padding: 0;
     justify-content: center;`}

  ${({ $collapsed, $active }) =>
    $collapsed &&
    !$active &&
    `background: ${tokens.surface.glass};
     border: 1px solid ${tokens.border.hairline};`}

  &:hover {
    background: ${tokens.surface.inset};
  }
  &:focus-visible {
    outline: 2px solid ${tokens.accent.base};
    outline-offset: 2px;
  }
`
